export const DEFAULT_PROJECTS = [
  {
    id: "1",
    title: "Hotel Costa Serena",
    slug: "hotel-costa-serena",
    sector: "Hotelería",
    location: "Punta del Este, Uruguay",
    year: "2024",
    description: "Un hotel boutique de 74 habitaciones frente al océano Atlántico. El proyecto articula una secuencia de volúmenes de hormigón visto y madera que enmarcan el paisaje costero. Los espacios comunes se organizan en torno a un patio central que introduce luz natural en todos los niveles, mientras las habitaciones se orientan hacia el mar con terrazas profundas que gradúan la transición entre interior y exterior.",
    services: ["Diseño Arquitectónico", "Diseño Interior", "Dirección de Obra"],
    hero_image: "https://images.unsplash.com/photo-1621293954908-907159247fc8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBpbnRlcmlvciUyMGRlc2lnbiUyMGhvdGVsfGVufDB8fHx8MTc4MzE2MDcxMXww&ixlib=rb-4.1.0&q=85",
    gallery: [
      "https://images.unsplash.com/photo-1747669842414-f71cbf5d106b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBpbnRlcmlvciUyMGRlc2lnbiUyMGhvdGVsfGVufDB8fHx8MTc4MzE2MDcxMXww&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=1600&q=85",
      "https://images.unsplash.com/photo-1618773928121-c32242e63f39?w=1600&q=85"
    ],
    featured: true,
    order: 1
  },
  {
    id: "2",
    title: "Centro Comercial Meridiano",
    slug: "centro-comercial-meridiano",
    sector: "Centros Comerciales",
    location: "Buenos Aires, Argentina",
    year: "2023",
    description: "Renovación integral de un centro comercial de 45.000 m². La intervención reorganiza los flujos de circulación mediante un atrio longitudinal cubierto por una estructura de acero y vidrio que baña de luz natural los tres niveles comerciales. La paleta material —hormigón pulido, acero negro y madera clara— construye una atmósfera contemporánea que eleva la experiencia de compra.",
    services: ["Arquitectura", "Planificación Espacial", "Gestión de Proyecto"],
    hero_image: "https://images.unsplash.com/photo-1519567241046-7f570eee3ce6?w=1600&q=85",
    gallery: [
      "https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?w=1600&q=85",
      "https://images.unsplash.com/photo-1567449303078-57ad995bd329?w=1600&q=85"
    ],
    featured: true,
    order: 2
  },
  {
    id: "3",
    title: "Casa Horizonte",
    slug: "casa-horizonte",
    sector: "Viviendas",
    location: "José Ignacio, Uruguay",
    year: "2024",
    description: "Vivienda unifamiliar de 420 m² implantada sobre una duna frente al mar. Un único volumen horizontal de hormigón se posa sobre el terreno natural, elevándose para liberar la vista hacia el horizonte. El programa se desarrolla en una sola planta organizada por un muro longitudinal que separa las áreas sociales, abiertas al paisaje, de las áreas privadas, protegidas y silenciosas.",
    services: ["Diseño de Concepto", "Diseño Arquitectónico", "Supervisión de Construcción"],
    hero_image: "https://images.unsplash.com/photo-1453586857165-eb78d44460ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwYXJjaGl0ZWN0dXJlJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzgzMTYwNzExfDA&ixlib=rb-4.1.0&q=85",
    gallery: [
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1600&q=85",
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1600&q=85",
      "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=1600&q=85"
    ],
    featured: true,
    order: 3
  },
  {
    id: "4",
    title: "Resort Alma del Mar",
    slug: "resort-alma-del-mar",
    sector: "Hotelería",
    location: "Riviera Maya, México",
    year: "2022",
    description: "Complejo turístico de 120 llaves distribuido en pabellones de baja altura integrados en la vegetación tropical. El proyecto propone una arquitectura de sombras: pérgolas, celosías y aleros profundos que filtran la luz caribeña y generan espacios intermedios de gran calidad ambiental. Los materiales locales —piedra caliza, madera tropical certificada y chukum— anclan el proyecto a su contexto.",
    services: ["Arquitectura", "Diseño Interior", "Coordinación Técnica"],
    hero_image: "https://images.pexels.com/photos/9458996/pexels-photo-9458996.jpeg",
    gallery: [
      "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=1600&q=85",
      "https://images.unsplash.com/photo-1540541338287-41700207dee6?w=1600&q=85"
    ],
    featured: true,
    order: 4
  },
  {
    id: "5",
    title: "Residencial Los Álamos",
    slug: "residencial-los-alamos",
    sector: "Viviendas",
    location: "Montevideo, Uruguay",
    year: "2023",
    description: "Conjunto residencial de 36 unidades organizado en dos bloques paralelos unidos por un jardín central comunitario. La fachada de hormigón prefabricado establece un ritmo riguroso de llenos y vacíos que otorga identidad al conjunto, mientras los balcones corridos extienden el espacio doméstico hacia el exterior.",
    services: ["Diseño Arquitectónico", "Documentación Técnica", "Gestión de Proyecto"],
    hero_image: "https://images.pexels.com/photos/14528986/pexels-photo-14528986.jpeg",
    gallery: [
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1600&q=85",
      "https://images.unsplash.com/photo-1487958449943-2429e8be8625?w=1600&q=85"
    ],
    featured: true,
    order: 5
  }
];

export const getStoredProjects = () => {
  try {
    const custom = localStorage.getItem("custom_projects");
    if (custom) {
      const parsed = JSON.parse(custom);
      if (Array.isArray(parsed) && parsed.length > 0) return parsed;
    }
  } catch (e) {}
  return DEFAULT_PROJECTS;
};

export const saveStoredProjects = (projects) => {
  try {
    localStorage.setItem("custom_projects", JSON.stringify(projects));
  } catch (e) {}
};
